<template>
  <div class="bottom">
    <div class="container footer" v-if="!isPhone">
      <!-- <div class="container-arrow">
        <a
          href="javascript:"
          v-scroll-to="{
              el: '.footer',
              container:'body',
              duration: 300,
              easing: 'linear',
              offset: -50,
              force: true,
              cancelable: true,
              x: false,
              y: true
            }"
        >
          <img src="/static/img/arrow_adv.png" alt style="width: 12px;height: 6px;" />
        </a>
      </div> -->
      <!--羊驼平台其他-->
      <div class="container-content container-footer">
        <a
          href="https://www.ytaxx.com/"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', 'PTE导流入口', 'PTE导流入口']);"
          ><img src="/static/img/pic_bottom_PTE.png" alt="羊驼PTE"
        /></a>
        <a
          href="https://ytaxx.com/det"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '羊驼多邻国导流入口', '羊驼多邻国导流入口']);"
          ><img src="/static/img/pic_bottom_Duolingo.png" alt="羊驼多邻国"
        /></a>
        <a
          href="https://yangtuoedu.com/static/en/index.html"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '通用英语导流入口', '通用英语导流入口']);"
          ><img src="/static/img/pic_bottom_English.png" alt="羊驼英语"
        /></a>
        <a
          href="https://www.yangtuoedu.com/kr"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '韩语导流入口', '韩语导流入口']);"
          ><img src="/static/img/pic_bottom_korean.png" alt="羊驼韩语"
        /></a>
        <a
          href="http://yangtuoedu.com/jp"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '羊驼日语', '羊驼日语']);"
          ><img src="/static/img/pic_bottom_japanese.png" alt="羊驼日语"
        /></a>
        <a
          href="http://ymlx.ytaxx.com/"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '移民留学平台导流入口', '移民留学平台导流入口']);"
          ><img src="/static/img/pic_bottom_ymlx.png" alt="移民留学互助平台"
        /></a>
      </div>
      <div class="container-content">
        <div class="container-content-width">
          <div class="footer-content">
            <div class="footer-top-left">
              <img src="/static/img/pic_logo_IELTS.png" alt />
              <p style="font-size: 22px;">轻松应对，努力不白费！</p>
              <p>
                携手每一个有梦想的人，去看更大的世界！
                <br />羊驼雅思，旅程开始的地方
              </p>
            </div>
            <div class="footer-top-right" style="margin-left: 300px">
              <p>Contact</p>
              <p>地址：湖南长沙市岳麓区 中电软件园二期C3栋</p>
              <p>联系电话：0731 - 85816616</p>
              <p>邮箱：mkt@yangtuoedu.com</p>
            </div>
            <div class="footer-top-right">
              <p>About</p>
              <p
                style="position: relative;cursor: pointer"
                @mouseenter="isShowCollab = true"
                @mouseleave="isShowCollab = false"
              >
                商务合作
                <transition name="fade">
                  <div class="header-right-silde1" v-if="isShowCollab">
                    <img src="/static/img/b_hover_cooperation.png" alt />
                  </div>
                </transition>
              </p>
              <!-- <a href="https://www.ytaxx.com/info/27962.html" target="_blank">
                <p style="cursor: pointer">加入我们</p>
              </a> -->
            </div>
          </div>
          <div class="footer-bottom">
            <a target="_blank" href="http://www.beian.miit.gov.cn">
              <p>©湖南羊驼教育科技有限公司 备案号：湘ICP备18003463号-1</p>
            </a>
            <div class="footer-bottom-right">
              <a
                href="https://yangtuo.ke.qq.com/?tuin=7667aa89#tab=1&category=-1"
                target="_blank"
              >
                <img src="/static/img/icon_bottom_tencent.png" alt />
              </a>
              <a
                href="https://weidian.com/item_classes.html?userid=1665500800&c=127978567&wfr=wx_wxh5&ifr=shopdetail"
                target="_blank"
              >
                <img src="/static/img/icon_bottom_weidian.png" alt />
              </a>
              <a
                href="https://shop204393257.taobao.com/search.htm?search=y&keyword=%D1%C5%CB%BC&lowPrice=&highPrice="
                target="_blank"
              >
                <img src="/static/img/icon_bottom_taobao.png" alt />
              </a>
              <a
                href="javascript:"
                target="_blank"
                style="position: relative"
                @mouseenter="isShowWechat = true"
                @mouseleave="isShowWechat = false"
              >
                <img src="/static/img/icon_bottom_wechat.png" alt />
                <transition name="fade">
                  <div class="header-top-silde" v-if="isShowWechat">
                    <img src="/static/img/b_hover_wechat.png" alt />
                  </div>
                </transition>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container footer" v-if="isPhone">
      <!--羊驼平台其他-->
      <div class="container-content container-footer">
        <a
          href="https://www.ytaxx.com/"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', 'PTE导流入口', 'PTE导流入口']);"
          ><img src="/static/img/pic_bottom_PTE.png" alt="羊驼PTE"
        /></a>
        <a
          href="https://ytaxx.com/det"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '羊驼多邻国导流入口', '羊驼多邻国导流入口']);"
          ><img src="/static/img/pic_bottom_Duolingo.png" alt="羊驼多邻国"
        /></a>
        <a
          href="https://yangtuoedu.com/static/en/index.html"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '通用英语导流入口', '通用英语导流入口']);"
          ><img src="/static/img/pic_bottom_English.png" alt="羊驼英语"
        /></a>
        <a
          href="https://www.yangtuoedu.com/kr"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '韩语导流入口', '韩语导流入口']);"
          ><img src="/static/img/pic_bottom_korean.png" alt="羊驼韩语"
        /></a>
        <a
          href="http://yangtuoedu.com/jp"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '羊驼日语', '羊驼日语']);"
          ><img src="/static/img/pic_bottom_japanese.png" alt="羊驼日语"
        /></a>
        <a
          href="http://ymlx.ytaxx.com/"
          target="_blank"
          onclick=" _czc.push(['_trackEvent', '移民留学平台导流入口', '移民留学平台导流入口']);"
          ><img src="/static/img/pic_bottom_ymlx.png" alt="移民留学互助平台"
        /></a>
      </div>
      <div class="container-content">
        <div class="container-content-width">
          <div class="footer-content">
            <div class="footer-top-left">
              <img src="/static/img/pic_logo_IELTS.png" alt />
              <p style="font-size: 22px;">轻松应对，努力不白费！</p>
              <p>
                携手每一个有梦想的人，去看更大的世界！
                <br />羊驼雅思，旅程开始的地方
              </p>
            </div>
            <div
              style="display: flex;justify-content: space-between;margin-top: 30px;"
            >
              <div class="footer-top-right" style="margin-left: 300px">
                <p>Contact</p>
                <p>地址：湖南长沙市岳麓区 中电软件园二期C3栋</p>
                <p>联系电话：0731 - 85816616</p>
                <p>邮箱：mkt@yangtuoedu.com</p>
              </div>
              <div class="footer-top-right">
                <p>About</p>
                <p style="position: relative;cursor: pointer">
                  商务合作
                  <transition name="fade">
                    <div class="header-right-silde1" v-if="isShowCollab">
                      <img src="/static/img/b_hover_cooperation.png" alt />
                    </div>
                  </transition>
                </p>
                <!-- <a href="https://www.ytaxx.com/info/27962.html" target="_blank">
                  <p style="cursor: pointer">加入我们</p>
                </a> -->
              </div>
            </div>
          </div>
          <div class="footer-bottom">
            <a
              target="_blank"
              href="http://www.miitbeian.gov.cn/state/outPortal/loginPortal.action;jsessionid=07XDALttRcmS9kOQpgRnJH4kYaIOJCUBRVyORfCySDwNP3A4opby!-2108032504"
            >
              <p>©湖南羊驼教育科技有限公司 备案号：湘ICP备18003463号-1</p>
            </a>
            <div class="footer-bottom-right">
              <a
                href="https://yangtuo.ke.qq.com/?tuin=7667aa89#tab=1&category=-1"
                target="_blank"
              >
                <img src="/static/img/icon_bottom_tencent.png" alt />
              </a>
              <a
                href="https://weidian.com/item_classes.html?userid=1665500800&c=127978567&wfr=wx_wxh5&ifr=shopdetail"
                target="_blank"
              >
                <img src="/static/img/icon_bottom_weidian.png" alt />
              </a>
              <a
                href="https://shop204393257.taobao.com/search.htm?search=y&keyword=%D1%C5%CB%BC&lowPrice=&highPrice="
                target="_blank"
              >
                <img src="/static/img/icon_bottom_taobao.png" alt />
              </a>
              <a
                href="javascript:"
                target="_blank"
                style="position: relative"
                @mouseenter="isShowWechat = true"
                @mouseleave="isShowWechat = false"
              >
                <img src="/static/img/icon_bottom_wechat.png" alt />
                <transition name="fade">
                  <div class="header-right-silde" v-if="isShowWechat">
                    <img src="/static/img/b_hover_wechat.png" alt />
                  </div>
                </transition>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {
      isPhone: false,
      isShowWechat: false,
      isShowCollab: false
    };
  },
  mounted() {
    if (document.body.clientWidth <= 750) {
      this.isPhone = true;
    }
  }
};
</script>

<style lang="stylus" scoped>
.container {
  width: 100%;
  text-align: center;
}
.container-content-width {
  width: 1200px;
  margin: 0 auto;
}
.container-arrow {
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;

  a {
    line-height: 35px;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 50%;
    display: inline-block;
    width: 138px;
    height: 35px;
    transform: rotate(180deg) translateX(50%);
    text-align: center;
    background: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'138\' height=\'35\' viewBox=\'0 0 138 35\'%3E%3Cpath fill=\'%23fff\' d=\'M 3.15027 34.4375C 1.74207 34.6025 0.68396 34.7266 0 35L 68.9982 35C 68.9982 35 68.9998 28.6387 69 19.5132C 69 20.7261 69.0001 21.8892 69.0001 22.9956L 69.0018 35L 138 35C 137.316 34.7266 136.258 34.6025 134.85 34.4375C 131.11 33.9995 124.903 33.2729 116.678 28.6875C 111.015 25.3901 106.523 20.9771 102.07 16.6025C 93.5474 8.23096 85.1685 -1.97984e-15 69.0018 3.55056e-31C 69.0006 5.271 69 10.4292 69 15.0952C 69 10.4287 68.9994 5.27148 68.9982 3.55056e-31C 52.8314 1.97986e-15 44.4526 8.23096 35.9302 16.6025C 31.4772 20.9771 26.985 25.3901 21.3221 28.6875C 13.0974 33.2729 6.88965 33.9995 3.15027 34.4375Z\'/%3E%3C/svg%3E");

    img {
      transform: rotate(180deg);
    }
  }
}
/* 底部 */
.footer {
  height: 440px;
  /* autoprefixer: off */
  background: linear-gradient(left, #1376f8, #53a4f4);
  /* autoprefixer: on */
  background: -o-linear-gradient(left, #1376f8, #53a4f4);
  background: -moz-linear-gradient(left, #1376f8, #53a4f4);
  background: -webkit-linear-gradient(left, #1376f8, #53a4f4);
position: relative;
    padding-top: 4rem;
    margin-top: 100px;
    .container-footer{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
        position: absolute;
        top: -65px;
        left: 0;
        right: 0;
        margin: 0 auto;
        padding: 0;
    }
  .footer-content {
    margin-top: 80px;
    display: flex;
    justify-content: space-between;
    position: relative;

    div {
      text-align: left;
    }

    .footer-top-left {
      img {
        width: 149px;
        height: 39px;
      }

      p {
        color: #fff;
        margin: 8px 0;
      }
    }

    .footer-top-right {
      p {
        color: #fff;
        margin: 16px 0;
        padding-left: 90px;
      }
    }
  }

  .footer-content::after {
    position: absolute;
    bottom: -20px;
    left: 50%;
    display: block;
    width: 80%;
    height: 1px;
    margin-left: -40%;
    content: '';
    /* autoprefixer: off */
    background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.2) 0, rgba(255, 255, 255, 0) 75%);
    /* autoprefixer: on */
    background: -webkit-radial-gradient(ellipse at center, rgba(0, 0, 0, 0.2) 0, rgba(255, 255, 255, 0) 75%);
    background: -o-radial-gradient(ellipse at center, rgba(0, 0, 0, 0.2) 0, rgba(255, 255, 255, 0) 75%);
    background: -moz-radial-gradient(ellipse at center, rgba(0, 0, 0, 0.2) 0, rgba(255, 255, 255, 0) 75%);
  }

  .footer-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;

    p {
      color: #fff;
      font-size: 14px;
    }

    .footer-bottom-right {
      display: flex;

      a {
        margin: 0 6px;

        img {
          width: 100%;
        }
      }
    }
  }
}
@media only screen and (max-width: 750px) and (min-width: 300px) {
  .footer {
      margin-top: 80px !important;
      padding-top: 150px !important;
      .container-footer{
          width:98%;
            display: block;
            top: -50px;
            img{
                width: 32%;
            }
      }
    .container-content-width {
      width: 90%;
      margin: 0 auto;
    }

    height: auto !important;

    .footer-content {
      display: block;
      margin-top: 20px;

      .footer-top-right {
        margin: 0 !important;

        p {
          margin: 6px 0;
          padding-left: 0;
          font-size: 12px;
        }
      }
    }

    .header-right-silde {
      right: -117px;
      top: -172px;
      width: 260px;
      background: none;

      img {
        width: 60%;
      }
    }

    .footer-bottom {
      flex-direction: column;
      align-items: center;

      .footer-bottom-right {
        margin: 20px 0;
      }
    }
  }
}
@media only screen and (max-width: 767px) and (min-width: 300px) {
  .footer {
    height: 150px;
    padding: 12px 0 0 0;
  }

  .footer-panel a img {
    width: 90px;
  }

  .footer-panel a p {
    font-size: 16px;
  }

  .footer-panel-content {
    right: 0;
    bottom: 70px;
    width: 100%;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue